var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');

var MarkAsForm = Marionette.View.extend({
    template: require('../../templates/documents/mark-as-form.html'),

    ui: {
        modal: '#mark-as-modal',
        comment: '#comment',
        time: '#mark-as-time',
        go: '#go',

        loader: '#mark-as-loader'
    },

    events: {
        'click @ui.go': 'onGo',
        'keyup @ui.comment': 'onCommentChanged'
    },

    templateContext: function () {
        var commentPalceholder;

        if (this.mode == "sent")
            commentPalceholder = "Please, specify following data - when, who sent, who will deliver";
        else if (this.mode == "delivered")
            commentPalceholder = "Please, specify following data - when, who delivered, who will received";
        else
            commentPalceholder = "Comment";

        return {
            mode: this.mode,
            commentPlaceholder: commentPalceholder
        }
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
        that.mode = options.mode
        that.documentsIds = options.docIds
        that.comment = ""
        that.sentDeliveredTime = 0
    },

    onRender: function () {
        var that = this;
        that.ui.time.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'MM/DD/YYYY hh:mm A',
            maxDate: new Date()
        });
        that.ui.time.on("dp.change", function (e) {

            if (e.date) {
                that.sentDeliveredTime = e.date.valueOf();
            } else {
                that.sentDeliveredTime = 0;
            }

            that.check()

        }).on('dp.show', function () {
            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
        });
        this.show();
    },

    onGo: function () {

        var that = this;

        var apiCalls = that.documentsIds.map(function (documentId) {

            return $.ajax({
                type: "POST",
                url: '/api/document/' + documentId + '/mark/as/' + that.mode,
                //data: jQuery.param(),
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                data: {time: that.sentDeliveredTime, comment: that.comment},
                statusCode: {
                    200: function (response) {
                    }
                },
                error: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);
                    that.utils.hideSpinner(that.ui.loader.id);
                }
            });

        });

        that.utils.showSpinner(that.ui.loader.id);

        $.when.apply($, apiCalls).then(function () {
            that.utils.hideSpinner(that.ui.loader.id);
            that.hide();
            $.notify({
                message: "Selected documents marked as " + that.mode
            }, {
                type: 'success',
                z_index: 2000,
            });
            if (that.getOption("woResponseEvent") !== true)
                that.triggerMethod("document:list:refresh");
        });
    },

    show: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    },

    onCommentChanged: function (event) {
        this.comment = event.target.value;
        this.check();
    },

    check: function () {

        if (_.isEmpty(this.documentsIds) || _.isEmpty(this.comment) || this.sentDeliveredTime == 0) {
            this.ui.go.attr('disabled', true);
        } else {
            this.ui.go.removeAttr('disabled');
        }
    }
});

module.exports = MarkAsForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/mark-as-form.js
// module id = 328
// module chunks = 0